import React, { useEffect, useState } from "react";

/* helper to set cookie (mirror what index.html did) */
function setCookie(name, value, days) {
  try {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days*24*60*60*1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    try {
      var host = window.location.hostname;
      if (host && host !== "localhost") {
        document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=." + host;
        document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=" + host;
      }
    } catch(e){}
  } catch(e) { console.warn(e); }
}

const pageLang = "en"; // default page language

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "hi", label: "Hindi" },
  { code: "id", label: "Indonesian" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "pa", label: "Punjabi" },
  { code: "ru", label: "Russian" },
  { code: "sw", label: "Kiswahili" },
  { code: "es", label: "Spanish" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
  { code: "tr", label: "Turkish" },
  { code: "ur", label: "Urdu" },
  { code: "vi", label: "Vietnamese" },
  { code: "zh-CN", label: "Chinese (Simplified)" },
  { code: "bn", label: "Bengali" },
  { code: "de", label: "German" },
  { code: "ar", label: "Arabic" },
  { code: "pt", label: "Portuguese" }
];


export default function LanguageSwitcher() {
  const [current, setCurrent] = useState(() => {
    try {
      return localStorage.getItem("lang") || (navigator.language || "en").split("-")[0];
    } catch(e) { 
      return (navigator.language || "en").split("-")[0]; 
    }
  });

  useEffect(() => {
    // Keep select synced if cookie changes elsewhere
    const onFocus = () => {
      const saved = localStorage.getItem("lang");
      if (saved && saved !== current) setCurrent(saved);
    };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [current]);

  function applyLang(lang) {
    const val = `/${pageLang}/${lang}`;
    try { localStorage.setItem("lang", lang); } catch(e){}
    setCookie("googtrans", val, 365);

    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = lang;
      combo.dispatchEvent(new Event("change"));
      setCurrent(lang);

      // Retry after small delay in case iframe not ready
      setTimeout(() => {
        const combo2 = document.querySelector(".goog-te-combo");
        if (combo2) {
          combo2.value = lang;
          combo2.dispatchEvent(new Event("change"));
        }
      }, 500);
    } else {
      window.location.reload();
    }
  }

  return (
    <div style={{ 
      
    }}>
      <label style={{ fontSize: 16, fontWeight: "bold" }}></label>
      <select
        value={current}
        onChange={(e) => applyLang(e.target.value)}
        style={{
          padding: "10px 15px",
          fontSize: "16px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          cursor: "pointer",
          minWidth: "180px",
          textTransform: "capitalize"
        }}
      >
        {LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
}
